// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "socialcam-frontend/css/" + chunkId + "." + "e966249b" + ".css";
};